import * as types from './types'
import { processRecords } from '@/store/utils'
import { uuid } from 'vue-uuid'

const getDate = date => {
  let d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return formatDate(d)
}

const formatDate = date => {
  var monthNames = [
    'Janeiro', 'Fevereiro', 'Março',
    'Abril', 'Maio', 'Junho', 'Julho',
    'Agosto', 'Setembro', 'Outubro',
    'Novembro', 'Dezembro'
  ]

  var day = date.getDate()
  var monthIndex = date.getMonth()
  var year = date.getFullYear()

  return day + ' ' + monthNames[monthIndex] + ' ' + year
}

const groupByInsertedAt = (items) => items.reduce(
  (result, item) => ({
    ...result,
    [getDate(item['insertedAt'].toDate())]: [
      ...(result[getDate(item['insertedAt'].toDate())] || []),
      item
    ]
  }),
  {}
)

const actions = {
  INIT ({ commit, firebase }) {},
  async [types.GET_LIST] ({ commit, firebase, rootGetters }) {
    const currentCompany = rootGetters['global/currentCompanyId']
    const companyRef = firebase.firestore().doc(`companies/${currentCompany}`)
    const company = await firebase.firestore().collection('companies').doc(currentCompany).get()
    const price = company.data().comunications.letter.price

    firebase
      .firestore()
      .collection(`financial`)
      .where('companyRef', '==', companyRef)
      .onSnapshot(querySnapshot => {
        let records = processRecords(querySnapshot)

        const obj = groupByInsertedAt(records)

        let result = []
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            const arr = obj[prop]
            result.push({
              date: prop,
              qtd: arr.length,
              unitPrice: price,
              list: arr,
              totalValue: (price * arr.length),
              type: 'letter',
              id: uuid.v4()
            })
          }
        }

        commit('setList', result)
      })
  }
}

export default actions
